import axios from 'axios';
import {
  EXPORT_RESPONSE_FAIL,
  EXPORT_RESPONSE_LOADING,
  EXPORT_RESPONSE_SUCCESS,
  RESPONSE_FAIL,
  RESPONSE_LOADING,
  RESPONSE_SUCCESS,
} from '../types';

export const getResponses =
  (formId, index, pageSize, searchTerm, startDate, endDate) => async (dispatch) => {
    dispatch({
      type: RESPONSE_LOADING,
    });
    try {
      const params = {
        formId,
        index,
        pageSize,
        searchTerm,
      };

      params.startDate = startDate.toISOString();
      params.endDate = endDate.toISOString();

      const response = await axios.get('/api/responses', { params });

      dispatch({
        type: RESPONSE_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({
        type: RESPONSE_FAIL,
        payload: { error: err?.response?.data.message || err.message },
      });
    }
  };

export const deleteResponses =
  (formId, index, pageSize, searchTerm, startDate, endDate, selectedRows = []) =>
  async (dispatch) => {
    dispatch({
      type: RESPONSE_LOADING,
    });

    try {
      await axios.delete('/api/responses', {
        data: {
          responseIds: selectedRows,
        },
        params: {
          formId,
        },
      });

      dispatch(getResponses(formId, index, pageSize, searchTerm, startDate, endDate));
    } catch (err) {
      dispatch({
        type: RESPONSE_FAIL,
        payload: { error: err?.response?.data.message || err.message },
      });
    }
  };

export const exportResponses =
  (formId, searchTerm, startDate, endDate, browserTimeZone) => async (dispatch) => {
    dispatch({
      type: EXPORT_RESPONSE_LOADING,
    });

    try {
      const params = {
        formId,
        searchTerm,
        browserTimeZone,
      };
      params.startDate = startDate.toISOString();
      params.endDate = endDate.toISOString();

      const axiosResponse = await axios({
        method: 'get',
        url: '/api/responses/export',
        params,
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([axiosResponse.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'WhatsForm-Responses.csv');
      link.click();
      link.remove();

      dispatch({
        type: EXPORT_RESPONSE_SUCCESS,
      });
    } catch (err) {
      dispatch({
        type: EXPORT_RESPONSE_FAIL,
        payload: { error: err?.response?.data.message || err.message },
      });
    }
  };
